// Central GTM dataLayer helper.
//
// GTM (container GTM-MHGCCJN) is initialised in App.js via react-gtm-module,
// which guarantees window.dataLayer exists. Every custom event the site fires
// goes through pushDataLayer so the payload shape stays consistent and is easy
// to wire up to triggers/variables in the GTM UI.
//
// See docs/analytics-tracking-spec.md for the full event reference.

function currentSite() {
  const first = new URL(window.location).pathname.split("/").filter(Boolean)[0];
  if (first === "hcp") return "hcp";
  if (first === "patient") return "patient";
  return first || "root";
}

export function pushDataLayer(event, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    site: currentSite(),
    page_path: window.location.pathname,
    ...params,
  });
}

// --- Convenience wrappers for the three tracked behaviours ---------------

export function trackScrollDepth(percent) {
  pushDataLayer("scroll_depth", { scroll_percent: percent });
}

export function trackCtaClick({ text, destination, location }) {
  pushDataLayer("cta_click", {
    cta_text: (text || "").trim(),
    cta_destination: destination || "",
    cta_location: location || "",
  });
}

export function trackFormEvent(event, formName, params = {}) {
  pushDataLayer(event, { form_name: formName, ...params });
}
